export type ResultsTab = "experts" | "deals" | "research";

export interface TabCounts {
  experts: number;
  deals: number;
  research: number;
}

export interface TabVisibility {
  /** Visible tabs in display order: Experts, Deals, Research. */
  tabs: ResultsTab[];
  showTabChrome: boolean;
  defaultTab: ResultsTab | null;
}

const TAB_ORDER: ResultsTab[] = ["experts", "deals", "research"];

/**
 * Decide which tabs to render and whether to show tab chrome.
 * A single populated tab renders its table directly — no chrome — so deals-only
 * and research-only turns look exactly as they always have. With two or more,
 * the switcher appears and the first visible tab (Experts first) is the default.
 */
export function decideTabVisibility(counts: TabCounts): TabVisibility {
  const tabs = TAB_ORDER.filter((tab) => counts[tab] > 0);
  return {
    tabs,
    showTabChrome: tabs.length >= 2,
    defaultTab: tabs[0] ?? null,
  };
}
